export function buildRegistrationPayload(slug, values, fields = []) {
  const formData = {};
  const payload = { slug };

  fields.forEach((field) => {
    if (field.type === 'school') {
      ['school_province', 'school_ward', 'school_name'].forEach((key) => {
        if (values[key] !== undefined && values[key] !== null) {
          formData[key] = values[key];
          payload[key] = values[key];
        }
      });
      return;
    }

    const raw = values[field.name];
    if (raw === undefined || raw === null) {
      return;
    }

    let value = raw;
    if (field.type === 'date' && raw.format) {
      value = raw.format('YYYY-MM-DD');
    }

    formData[field.name] = value;
    payload[field.name] = value;
  });

  payload.form_data = JSON.stringify(formData);
  return payload;
}
